module.exports = __webpack_public_path__ + "static/media/banner.1c98c53a.png";